import React from 'react';
import { FormattedMessage } from 'react-intl';

// constants
import { RECIPIENT_FILTER_FIELD_NAMES } from '../../../../../../constraints';

// hooks
import { useRecipientStatusOptions } from '../../hooks/useRecipientStatusOptions';

// Components
import { ControlledSelectField } from '../../../../../../components/ControlledSelectField/ControlledSelectField';
import { FieldLabel } from '../../../../../../components/Form';

const SelectStatusField = ({
  name = RECIPIENT_FILTER_FIELD_NAMES.STATUS,
  onClear,
  isClearable,
}) => {
  const { statusOptions } = useRecipientStatusOptions();

  return (
    <>
      <FieldLabel>
        <FormattedMessage id="Status" defaultMessage="Status" />
      </FieldLabel>
      <ControlledSelectField
        name={name}
        options={statusOptions}
        onClear={onClear}
        isClearable={isClearable}
      />
    </>
  );
};

export default SelectStatusField;
